import React, {
  FC,
  useState,
  useRef,
  ChangeEvent,
  FormEvent,
  useEffect,
} from "react";
import "./CSS/LoginPage.css";
import Logo from "../Assets/Logo.svg";
import LoginImage from "./../Assets/LoginBackground.png";
import loginVideoUrls from "../Assets/LogInVideos.json";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Typography, Box, CircularProgress } from "@mui/material";
import { Input } from "../Components/ui/input";
import { Button } from "../Components/ui/button";
import { Label } from "../Components/ui/label";
// import { ToastContainer, toast } from "react-toastify";
import config from "../config.json";
import { ArrowLeftIcon, CheckIcon } from "@radix-ui/react-icons";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../Components/ui/select";
import "../Styles/globals.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { UseSelector } from "react-redux";
import {
  setAccountId,
  setAuthProfileBack,
  setBaseBillingCountryAuth,
  setworkspace,
  setWorkspaceData,
  setWorkspaceId,
  setisAuthstate,
  setBaseBillingCountryLabel,
  setRoleId,
} from "../State/slices/AuthenticationSlice";
import {
  setCloseAddWorkspaceDialog,
  setPermissions,
  setUser_Role_Name,
  setWorkspace_Count,
} from "../State/slices/AdvertiserAccountSlice";
import { RootState } from "../State/store";
import { useToast } from "../Components/ui/use-toast";
import { Toaster } from "../Components/ui/toaster";
import { Weight } from "lucide-react";
import { error } from "console";
import { Dialpad } from "@mui/icons-material";
//import ProgressBar from "../Pages/ProgressBarAuthentication";
import * as ct from "countries-and-timezones";
import { useMemo } from "react";
import ProgressBar from "./ProgressBarAuthentication";

// import type { WorkspaceInfo } from "../State/slices/AuthenticationSlice";

const getTimezonesByCountryISO = (
  isoCode: string
): { name: string; utcOffsetStr: string }[] => {
  const timezones = ct.getTimezonesForCountry(isoCode.toUpperCase());
  return (
    timezones?.map((tz: { name: any; utcOffsetStr: any }) => ({
      name: tz.name,
      utcOffsetStr: tz.utcOffsetStr,
    })) || []
  );
};

interface CustomWorkspaceControlProps {
  setNext: React.Dispatch<React.SetStateAction<boolean>>; // Type for setNext
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  isInvited: boolean;
}

export const CustomWorkspaceControl: FC<CustomWorkspaceControlProps> = ({
  setNext,
  setAuthenticated,
  isInvited,

}) => {
  const [companyName, setCompanyName] = useState("");
  const [CompanyNameError, setFirstNameError] = useState<string | null>(null);

  const [billingCountry, setBillingCountry] = useState("United Arab Emirates"); // ✅ Label-based default
  const [selectedTimezone, setSelectedTimezone] = useState(
    "Asia/Dubai (UTC+04:00)"
  );

  const [selectedIndustry, setSelectedIndustry] = useState("11");

  const [selectedWorkspaceType, setSelectedWorkspaceType] = useState("1"); //Default to "Advertiser"

  const [fileName, setFileName] = useState("");
  const [base64Image, setBase64Image] = useState("");
  const location = useLocation();
  const email = location.state?.email || "";
  const [apiUrl, setApiUrl] = useState("");
  const [OperatorUrl, setOperatorUrl] = useState("");
  const [authapiUrl, setAuthApiUrl] = useState("");
  const [accountIdentifier, setAccountIdentifier] = useState<number>();

  // const [countryTimezones, setCountryTimezones] = useState<{ name: string; utcOffsetStr: string }[]>([]);

  const [industries, setIndustries] = useState<{ id: number; label: string }[]>(
    []
  );

  const [isOperatorDomain, setIsOperatorDomain] = useState<boolean>(false);

  const [workspace_types, SetWorkspaceTypes] = useState<
    { id: number; label: string }[]
  >([]);

  const emailId = useSelector(
    (state: RootState) => state.authentication.userEmail
  );
  const workspaceList = useSelector(
    (state: RootState) => state.advertiserAccount.workspace_list
  ); // ✅ Access workspace list from Redux

  const workspaceNames = workspaceList.map((workspace: any) =>
    workspace.workspace_name.toLowerCase().trim()
  ); // Extract workspace names only

  const [isButtonDisabled, setIsButtonDisabled] = useState(false); // State to track button disable status

  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
  const [createworkspaceId, setcreateworkspaceId] = useState<number | null>(null);
  //
  const [loading, setLoading] = useState(true);
  const [OperatorType, setOperatorType] = useState(false);

  const navigate = useNavigate();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();

  const userIP = useSelector(
    (state: RootState) => state.authentication.userIP
  );

  const signupData = useSelector(
    (state: RootState) => state.authentication.signupData
  );
  const personalData = useSelector(
    (state: RootState) => state.authentication.userData
  );

  const firstName = useSelector(
    (state: RootState) => state.authentication.userData?.firstName
  );

  const lastName = useSelector(
    (state: RootState) => state.authentication.userData?.lastName
  );



  const addWorkspaceFromDropdown = useSelector(
    (state: RootState) => state.advertiserAccount.addWorkspaceFromDropdown
  );
  interface WorkspaceInfo {
    email: string;
    workspaceName: string;
    billingCountry: string;
    workspaceIndustry: string;
    workspaceType: string;
    status: string;
    createdBy: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
    mappingId: number;
    base64Image: string;
    billing_country_iso?: string;
    utc_timezone?: string;
  }

  const workspaceData = useSelector(
    (state: RootState) => state.authentication.workspaceData as WorkspaceInfo
  );

  const baseBillingCountry = useSelector(
    (state: RootState) => state.authentication.billingcountry
  );
  console.log("Base Billing Country:", baseBillingCountry);
  const baseworkspace_id = useSelector(
    (state: RootState) => state.authentication.workspace_id
  );
  const advUrl = useSelector((state: RootState) => state.authentication.apiURL);
  const baseBillingCountryCode = useSelector(
    (state: RootState) => state.authentication.billingcountry
  );
  const workspacecount = useSelector(
    (state: RootState) => state.advertiserAccount.workspace_count
  );
  const accountId = useSelector((state: RootState) => state.authentication.account_id);

  const isAdmin = useSelector(
    (state: RootState) => state.authentication.isAdmin
  );
  console.log(isAdmin);
  const toast = useToast();

  useEffect(() => {
    setLoading(true);
    GetWorkspaceDetailsByID();
    fetch("/config.json")
      .then((response) => response.json())
      .then((config) => {
        //console.log("config :", config);
        setApiUrl(config.API_URL); // Set the API URL from config
        setAuthApiUrl(config.API_URL); // set the Auth URL from config
        setOperatorUrl(config.OperatorUrl);
      })
      .catch((error) => {
        console.error("Error loading config:", error);
        toast.toast({
          title: "Error",
          description: "Something went wrong, please try again.",
        });
      });
  }, []);

  // Fetch domain list from API
  useEffect(() => {
    if (apiUrl) {
      fetchData();
    }
  }, [apiUrl]);

  const [countries, setCountries] = useState<
    { id: string; label: string; iso: string }[]
  >([]);
  const billingCountryISO = useSelector(
    (state: RootState) => state.authentication.billingcountry
  );
  console.log(
    "Billing Country ISO:i am hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    billingCountryISO
  );

  const billingCountryLabel = useSelector(
    (state: RootState) => state.authentication.baseBillingCountryLabel
  );

  // const [selectedTimezone, setSelectedTimezone] = useState<string>("");

  const [countryTimezones, setCountryTimezones] = useState(
    getTimezonesByCountryISO("AE")
  );

  useEffect(() => {
    if (!addWorkspaceFromDropdown && countries.length > 0) {
      // 💡 Match by label
      const defaultCountry = countries.find(
        (c) => c.label === "United Arab Emirates"
      );
      if (defaultCountry) {
        dispatch(setBaseBillingCountryAuth(defaultCountry.iso.toUpperCase())); // dispatch ISO

        const zones = getTimezonesByCountryISO(defaultCountry.iso);
        setCountryTimezones(zones);

        if (zones.length > 0) {
          const formatted = `${zones[0].name} (UTC${zones[0].utcOffsetStr})`;
          setSelectedTimezone(formatted);
        }
      }
    }
  }, [countries, addWorkspaceFromDropdown]);

  useEffect(() => {
    if (!addWorkspaceFromDropdown || !billingCountryISO) return;

    const zones = getTimezonesByCountryISO(billingCountryISO.toUpperCase());
    const formattedZones = zones.map(
      (tz) => `${tz.name} (UTC${tz.utcOffsetStr})`
    );
    setCountryTimezones(zones);

    const selectedZone =
      workspaceData && typeof workspaceData.utc_timezone === "string"
        ? workspaceData.utc_timezone
        : "";

    if (selectedZone && formattedZones.includes(selectedZone)) {
      setSelectedTimezone(selectedZone);
    } else if (formattedZones.length > 0) {
      setSelectedTimezone(formattedZones[0]);
    }
  }, [addWorkspaceFromDropdown, billingCountryISO, workspaceData]);

  const fetchData = async (): Promise<void> => {
    setLoading(true);
    try {
      await checkIfOperator(emailId);

      const countriesPromise = axios.get(`${apiUrl}/GetBillingCountryList`);
      const industriesPromise = axios.get(`${apiUrl}/GetIndustryList`);
      const workspacePromise = axios.get(`${apiUrl}/GetWorkspaceTypesList`);

      const [countriesResponse, industriesResponse, workspaceResponse] =
        await Promise.all([
          countriesPromise,
          industriesPromise,
          workspacePromise,
        ]);

      if (
        countriesResponse.data?.status === "Success" &&
        Array.isArray(countriesResponse.data.countryList)
      ) {
        const countriesData = countriesResponse.data.countryList.map(
          (country: { country_iso: string; country_name: string }) => ({
            id: country.country_iso, // country_iso as id
            label: country.country_name, // country_name as label
            iso: country.country_iso, // country_iso as iso
          })
        );
        setCountries(countriesData);
      } else {
        console.log(
          "No countries available in response or invalid status:",
          countriesResponse.data?.status_Description
        );
        setCountries([]); // Clear state if no valid data
      }

      // Transform and set industries
      if (industriesResponse.data?.industryList) {
        const industries = industriesResponse.data.industryList.map(
          (industry: { industry_id: number; industry_name: string }) => ({
            id: industry.industry_id,
            label: industry.industry_name,
          })
        );
        setIndustries(industries);
      } else {
        console.log("No industries available in response.");
      }

      // Transform and set workspace types
      if (workspaceResponse.data?.workspaceTypes) {
        const workspaceTypes = workspaceResponse.data.workspaceTypes.map(
          (workspace: { workspace_id: number; workspace_name: string }) => ({
            id: workspace.workspace_id,
            label: workspace.workspace_name,
          })
        );
        SetWorkspaceTypes(workspaceTypes);
      } else {
        console.log("No workspace types available in response.");
      }
    } catch (error) {
      console.error("Error fetching list data:", error);
      toast.toast({
        title: "Error",
        description: "Something went wrong, Please try again",
      });
    } finally {
      setLoading(false);
    }
  };

  const checkIfOperator = async (emailId: string) => {
    try {
      const response = await axios.get(`${apiUrl}/GetOperatorEmailDomains`);
      if (response.data.domains) {
        const domainList: string[] = response.data.domains;

        debugger;
        // Extract the domain part from the email
        const emailDomain = emailId.split("@")[1];
        const isAllowed = domainList.some(
          (allowedDomain) =>
            emailDomain === allowedDomain ||
            emailDomain.endsWith(`.${allowedDomain}`)
        );
        console.log(isAllowed);
        isAllowed ? setIsOperatorDomain(true) : setIsOperatorDomain(false);
      } else {
        console.log("No Operator Domains are Activated yet");
      }
    } catch (e) {
      console.error("Error Fetching Domain:", e);
    }
  };

  const checkOperatorType = (value: any) => {
    debugger;
    if (value === "2") {
      setOperatorType(true);
    } else {
      setOperatorType(false);
    }
  };

  const validateCompanyName = (value: string): boolean => {
    if (value.length === 0) {
      setFirstNameError("Company name cannot be empty.");
      return false;
    }

    // First character should NOT be a special character (letters & numbers allowed)
    const firstChar = value.charAt(0);
    const firstCharRegex = /^[a-zA-Z0-9]/; // Allows letters and numbers

    // Last character should NOT be a special character (letters & numbers allowed)
    const lastChar = value.charAt(value.length - 1);
    const lastCharRegex = /^[a-zA-Z0-9]$/; // Allows letters and numbers

    // Ensure spaces are allowed in between but not at the start or end
    if (!firstCharRegex.test(firstChar)) {
      setFirstNameError(
        "First character should not be a special character or space."
      );
      return false;
    } else if (!lastCharRegex.test(lastChar)) {
      setFirstNameError(
        "Last character should not be a special character or empty space."
      );
      return false;
    } else {
      setFirstNameError("");
    }

    setCompanyName(value);
    setFirstNameError(null);
    return true;
  };

  const handleFirstNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (validateCompanyName(value)) {
      console.log("Company Name is correct");
    } else {
      console.log("Company Name is incorrect");
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (!file) {
      setFileName("");
      setBase64Image("");
      return;
    }

    const validFileTypes = ["image/jpeg", "image/png"];
    const maxFileSize = 5 * 1024 * 1024; // 5MB

    const dotCount = (file.name.match(/\./g) || []).length;
    if (dotCount > 1) {
      toast.toast({
        title: "Error",
        description: "Invalid File name.",
      });
      setFileName("");
      setBase64Image("");
      return;
    }

    // Check file type
    if (!validFileTypes.includes(file.type)) {
      toast.toast({
        title: "Error",
        description: "Please select a valid image (PNG or JPEG).",
      });
      setFileName("");
      setBase64Image("");
      return;
    }

    // Check file size
    if (file.size > maxFileSize) {
      toast.toast({
        title: "Error",
        description: "File size should not exceed 5MB.",
      });
      setFileName("");
      setBase64Image("");
      return;
    }

    // Check image dimensions
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        if (img.width < 400 || img.height < 400) {
          toast.toast({
            title: "Error",
            description: "Image dimensions must be at least 400x400 pixels.",
          });
          setFileName("");
          setBase64Image("");
        } else {
          // Valid image

          setFileName(file.name);

          // Convert image to Base64
          const base64String = reader.result?.toString().split(",")[1]; // Remove metadata
          setBase64Image(base64String || "");
        }
      };
      img.onerror = () => {
        toast.toast({
          title: "Error",
          description: "Invalid image file.",
        });
        setFileName("");
        setBase64Image("");
      };
      img.src = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  };

  const handleAddWorkspaceFromDropdown = async (
    e: FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();
    if (CompanyNameError) return;
    if (!baseBillingCountry) {
      toast.toast({
        title: "Something went wrong , please try again.",
      });
      console.log("Billing country not set");
      return;
    }
    if (workspaceNames.includes(companyName.toLowerCase().trim())) {
      toast.toast({
        title: "Error",
        description: "Company name already exists for this email.",
      });
      console.log("Duplicate Company Name Found:", companyName);
      return; // Stop further execution if name already exists
    }
    setIsButtonDisabled(true); // Disable the button
    console.log("BILLING :", baseBillingCountry);
    console.log("Base Billing Country Code :", baseBillingCountryCode);
    debugger;
    // Format the timezone before adding to payload
    const formattedTimezone =
      countryTimezones.length > 0
        ? countryTimezones.find(
          (tz) => tz.name === selectedTimezone.split(" (UTC")[0]
        )?.name +
        ` (UTC${countryTimezones.find(
          (tz) => tz.name === selectedTimezone.split(" (UTC")[0]
        )?.utcOffsetStr
        })`
        : selectedTimezone;

    const payload = {
      email: emailId,
      workspaceName: companyName,
      billingCountry: billingCountryISO.toLowerCase(),
      workspaceIndustry:
        selectedIndustry === "Tourism" ? "11" : selectedIndustry,
      workspaceType:
        selectedWorkspaceType === "Advertiser" ? "1" : selectedWorkspaceType,
      status: "active",
      createdBy: 1,
      createdDate: new Date().toISOString(),
      updatedBy: 1,
      updatedDate: new Date().toISOString(),
      mappingId: 0,
      base64Image,
      IsWalletStatus: true,
      utc_timezone: formattedTimezone, // Now formatted as "Europe/London (UTC+00:00)"
    };

    console.log("Dialog data:", JSON.stringify(payload, null, 2));

    try {
      const workspaceId = await createWorkspace(payload);
      if (!workspaceId) throw new Error("Failed to retrieve workspace ID");

      await assignUserRoleDropdown(emailId, workspaceId); // Uses your existing function
      //await insertbillingstatus(workspaceId);

      // Update Redux state
      dispatch(setworkspace(companyName));
      dispatch(setWorkspaceId(workspaceId));
      setAuthenticated(true);
      dispatch(setCloseAddWorkspaceDialog(true));
      sessionStorage.removeItem("lastFetchedWorkspaceCount");
      dispatch(setWorkspace_Count(workspacecount + 1));

      setTimeout(() => {
        toast.toast({
          title: "Success",
          description: "Created Workspace",
        });
        navigate("/navbar/dashboard", {
          state: { path: companyName, email: emailId },
        });
      }, 1000);
    } catch (error) {
      handleError(error); // Uses your existing error handler
    } finally {
      setIsButtonDisabled(false);
    }
  };

  useEffect(() => {
    console.log("addworkspace: " + addWorkspaceFromDropdown);
  });

  // ✅ Add this new useEffect
  useEffect(() => {
    if (!addWorkspaceFromDropdown || !billingCountryISO) return;

    // 1. Clear any old timezones
    setCountryTimezones([]);
    setSelectedTimezone("");

    // 2. Load timezones for the current billing country ISO
    const zones = getTimezonesByCountryISO(billingCountryISO.toUpperCase());

    if (zones.length > 0) {
      setCountryTimezones(zones);

      // 3. Auto-select the first one
      const firstTz = zones[0];
      setSelectedTimezone(`${firstTz.name} (UTC${firstTz.utcOffsetStr})`);
    }
  }, [addWorkspaceFromDropdown, billingCountryISO]);


  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (CompanyNameError) return;

    setIsButtonDisabled(true); // Disable the button when clicked
    setLoading(true);

    let accountId: number | null = null;
    let workspaceId: number | null = null;

    // Format the timezone before adding to payload
    const formattedTimezone =
      countryTimezones.length > 0
        ? countryTimezones.find(
          (tz) => tz.name === selectedTimezone.split(" (UTC")[0]
        )?.name +
        ` (UTC${countryTimezones.find(
          (tz) => tz.name === selectedTimezone.split(" (UTC")[0]
        )?.utcOffsetStr
        })`
        : selectedTimezone;

    const getBillingCountryISO = () => {
      const match = countries.find((c) => c.label === billingCountry);
      return match?.id || billingCountry;
    };

    const payload = {
      email,
      workspaceName: companyName,
      billingCountry: getBillingCountryISO(),
      workspaceIndustry:
        selectedIndustry === "Tourism" ? "11" : selectedIndustry,
      workspaceType:
        selectedWorkspaceType === "Advertiser" ? "1" : selectedWorkspaceType,
      status: "active",
      createdBy: 1,
      createdDate: new Date().toISOString(),
      updatedBy: 1,
      updatedDate: new Date().toISOString(),
      mappingId: 0,
      base64Image,
      IsWalletStatus: true,
      utc_timezone: formattedTimezone,
    };

    dispatch(setworkspace(companyName));
    dispatch(setWorkspaceData(payload));
    dispatch(setBaseBillingCountryAuth(billingCountry));
    let status = "Success";
    try {
      await registerUser();
      await insertPersonalInfo();
      workspaceId = await createWorkspace(payload);
      setcreateworkspaceId(workspaceId);
      if (!workspaceId) throw new Error("Failed to retrieve workspace ID");

      const iso = getBillingCountryISO(); // e.g., "in"
      const tzs = getTimezonesByCountryISO(iso); // returns [{name: "Asia/Kolkata", ...}, ...]

const triggerN8NWebhook = async (isApproved: boolean) => {
  try {
    const isOperator = selectedWorkspaceType === "2";

    const payload = {
      request_type: isOperator ? "account_creation_operator" : "account_creation_advertiser",
      accountId: accountId,
      advertiserID: String(workspaceId),
      creator_email: emailId,
      creatorName: `${firstName} ${lastName}`,
      advertiserFirstname: firstName,
      advertiserLastname: lastName,
      companyName: companyName,
      billingCountry: billingCountry,
      timeZone: selectedTimezone,
      ...(!isOperator && {
        industryCategory: industries.find(i => i.id.toString() === selectedIndustry?.toString())?.label || selectedIndustry,
      }),
    };

    const response = await axios.post(`${apiUrl}/N8NAccountCreation`, payload);

    if (response.status !== 200) {
      console.error("❌ Webhook Trigger Failed");
    } else {
      console.log("✅ Webhook Triggered Successfully");
    }
  } catch (error) {
    console.error("❗ Error in triggerN8NWebhook", error);
  }
};


      const Operatorpayload = {
        partnerId: workspaceId,
        partnerName: companyName,
        partnerFirstname: firstName,
        partnerLastname: lastName,
        partnerEmailId: emailId,
        partnerStatus: "active",
        fromCountryIsoList: [getBillingCountryISO()],
        fromCountryTimezones: {
          [iso]: formattedTimezone, // take the first tz
        },
        autoApproval: false,
        s3FolderName: "",
        fileProcessingStatus: false,
        fileColumnMapping: JSON.stringify([]), // actual object, not string
        createdTime: new Date().toISOString(),
        lastUpdatedTime: new Date().toISOString(),
      };

      if (selectedWorkspaceType === "2") {
        const res = await insertOperatorSummary(Operatorpayload);
        if (!res) throw new Error("Failed to insert operator summary");
      }

      dispatch(setWorkspaceId(workspaceId));

      const selectedMode =
        selectedWorkspaceType === "2" ? "InsertOperator" : "InsertAdmin";
      await assignUserRole(email, selectedMode, workspaceId);
      const { path, workspaceType } = await fetchWorkspaceDetails(email);
      const selected_role_id =
        selectedWorkspaceType === "2" ? 11 : isAdmin ? 1 : 2;
      dispatch(setRoleId(selected_role_id));
      await fetchAndStorePermissions(selected_role_id);
      //await insertbillingstatus(workspaceId);
      await getaccountId(email);

      toast.toast({
        title: "SignUp Successful",
        description: "You have successfully signed up for our platform.",
      });

      //const accountId = await getaccountId(email);
      accountId = await getaccountId(email);
      if (!accountId) throw new Error("AccountId not found");

      const normalizedBillingCountry =
        billingCountry === "United Arab Emirates" ? "14" : billingCountry;

      if (!isInvited && workspaceType !== "Telecom Operator") {
        await createStarterPlan(accountId, normalizedBillingCountry);
      }

      await triggerN8NWebhook(true);

      setTimeout(() => {
        navigate(
          workspaceType === "Telecom Operator"
            ? "/operatorNavbar/dashboard"
            : "/navbar/dashboard",
          { state: { path, email } }
        );
        setNext(true);
      }, 2000);
    } catch (error) {
      status = "Failure";
      handleError(error);
    } finally {

      let auditDto = {
        UserAccountId: accountId, // Replace with actual user account ID
        CampaignId: 0, // Replace with actual campaign ID, if applicable
        AdvertiserWorkspaceId: workspaceId, // Replace with actual workspace ID
        Action: "SignUp platform", // Example action
        ActionPage: "sign up with workspace creation", // Example action page
        Status: status,
        BeforeData: JSON.stringify({}), // Empty JSON object
        AfterData: JSON.stringify({
          message: "You have successfully signed up to the platform"
        }), // Valid JSON object with a message
        IpAddress: userIP, // Replace with actual IP address
        Comments: "User signed up successfully",
      };

      try {
        await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
      } catch (auditError) {
        console.error("Failed to insert audit history:", auditError);
      }
      setIsButtonDisabled(false);
      setLoading(false);
    }
  };



  // const handleSubmit = async (e: FormEvent<HTMLFormElement>) => 
  //   {
  //     e.preventDefault();

  //     if (CompanyNameError) return;

  //     setIsButtonDisabled(true); // Disable the button when clicked
  //     setLoading(true);

  //     let accountId: number | null = null;
  //     let workspaceId: number | null = null;
  //     let path = "";
  //     let workspaceType = "";

  //     // Format the timezone before adding to payload
  //     const formattedTimezone =
  //       countryTimezones.length > 0
  //         ? countryTimezones.find(
  //           (tz) => tz.name === selectedTimezone.split(" (UTC")[0]
  //         )?.name +
  //         ` (UTC${countryTimezones.find(
  //           (tz) => tz.name === selectedTimezone.split(" (UTC")[0]
  //         )?.utcOffsetStr
  //         })`
  //         : selectedTimezone;

  //     const getBillingCountryISO = () => {
  //       const match = countries.find((c) => c.label === billingCountry);
  //       return match?.id || billingCountry;
  //     };

  //     const payload = {
  //       email,
  //       workspaceName: companyName,
  //       billingCountry: getBillingCountryISO(),
  //       workspaceIndustry:
  //         selectedIndustry === "Tourism" ? "11" : selectedIndustry,
  //       workspaceType:
  //         selectedWorkspaceType === "Advertiser" ? "1" : selectedWorkspaceType,
  //       status: "active",
  //       createdBy: 1,
  //       createdDate: new Date().toISOString(),
  //       updatedBy: 1,
  //       updatedDate: new Date().toISOString(),
  //       mappingId: 0,
  //       base64Image,
  //       IsWalletStatus: true,
  //       utc_timezone: formattedTimezone,
  //     };

  //     dispatch(setworkspace(companyName));
  //     dispatch(setWorkspaceData(payload));
  //     dispatch(setBaseBillingCountryAuth(billingCountry));
  //     let status = "Success";
  //     try {
  //       console.log("Starting user registration...");
  //       await registerUser();

  //       console.log("Inserting personal info...");
  //       await insertPersonalInfo();

  //       console.log("Creating workspace...");
  //       workspaceId = await createWorkspace(payload);
  //       setcreateworkspaceId(workspaceId);
  //       if (!workspaceId) throw new Error("Failed to retrieve workspace ID");

  //       const iso = getBillingCountryISO(); // e.g., "in"
  //       const tzs = getTimezonesByCountryISO(iso); // returns [{name: "Asia/Kolkata", ...}, ...]


  //       const Operatorpayload = {
  //         partnerId: workspaceId,
  //         partnerName: companyName,
  //         partnerFirstname: firstName,
  //         partnerLastname: lastName,
  //         partnerEmailId: emailId,
  //         partnerStatus: "active",
  //         fromCountryIsoList: [getBillingCountryISO()],
  //         fromCountryTimezones: {
  //           [iso]: formattedTimezone, // take the first tz
  //         },
  //         autoApproval: false,
  //         s3FolderName: "",
  //         fileProcessingStatus: false,
  //         fileColumnMapping: JSON.stringify([]), // actual object, not string
  //         createdTime: new Date().toISOString(),
  //         lastUpdatedTime: new Date().toISOString(),
  //       };

  //       if (selectedWorkspaceType === "2") {
  //         console.log("Inserting operator summary...");
  //         const res = await insertOperatorSummary(Operatorpayload);
  //         if (!res) throw new Error("Failed to insert operator summary");
  //       }

  //       dispatch(setWorkspaceId(workspaceId));

  //       console.log("Assigning user role...");
  //       const selectedMode =
  //         selectedWorkspaceType === "2" ? "InsertOperator" : "InsertAdmin";
  //       await assignUserRole(email, selectedMode,workspaceId);

  //       console.log("Fetching workspace details...");
  //       const workspaceDetails = await fetchWorkspaceDetails(email);
  //       path = workspaceDetails.path;
  //       workspaceType = workspaceDetails.workspaceType;

  //       console.log("Fetching permissions...");
  //       const selected_role_id =
  //         selectedWorkspaceType === "2" ? 11 : isAdmin ? 1 : 2;
  //       await fetchAndStorePermissions(selected_role_id);
  //       // await insertbillingstatus(workspaceId);

  //       console.log("Getting account ID...");
  //       await getaccountId(email);

  //       toast.toast({
  //         title: "SignUp Successful",
  //         description: "You have successfully signed up for our platform.",
  //       });

  //       //const accountId = await getaccountId(email);
  //       accountId = await getaccountId(email);
  //       if (!accountId) throw new Error("AccountId not found");

  //       const normalizedBillingCountry =
  //         billingCountry === "United Arab Emirates" ? "14" : billingCountry;

  //       if (!isInvited && workspaceType !== "Telecom Operator") {
  //         console.log("Creating starter plan...");
  //         try {
  //           await createStarterPlan(accountId, normalizedBillingCountry);
  //         } catch (planError) {
  //           console.error("Starter plan creation failed, but continuing:", planError);
  //           // Don't throw - allow signup to continue even if starter plan fails
  //         }
  //       }

  //       debugger

  //       console.log("All operations successful, preparing to navigate...");
  //       console.log("Navigation path:", workspaceType === "Telecom Operator" ? "/operatorNavbar/dashboard" : "/navbar/dashboard");
  //       console.log("Path state:", path);
  //       console.log("Email:", email);

  //       // Store navigation details for use in finally block
  //       const navigationDetails = {
  //         path: workspaceType === "Telecom Operator"
  //           ? "/operatorNavbar/dashboard"
  //           : "/navbar/dashboard",
  //         state: { path, email }
  //       };

  //       // Set authenticated state BEFORE navigation
  //       setAuthenticated(true);
  //       console.log("Authentication state set to true");

  //       // Audit logging before navigation
  //       let auditDto = {
  //         UserAccountId: accountId,
  //         CampaignId: 0,
  //         AdvertiserWorkspaceId: workspaceId,
  //         Action: "SignUp platform",
  //         ActionPage: "sign up with workspace creation",
  //         Status: status,
  //         BeforeData: JSON.stringify({}),
  //         AfterData: JSON.stringify({
  //           message: "You have successfully signed up to the platform"
  //         }),
  //         IpAddress: userIP,
  //         Comments: "User signed up successfully",
  //       };

  //       try {
  //         await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
  //       } catch (auditError) {
  //         console.error("Failed to insert audit history:", auditError);
  //       }

  //       // Navigate after a delay
  //       setTimeout(() => {
  //         console.log("Executing navigation now...");
  //         console.log("Navigating to:", navigationDetails.path);
  //         console.log("With state:", navigationDetails.state);

  //         try {
  //           setNext(true);
  //           navigate(navigationDetails.path, { state: navigationDetails.state, replace: true });
  //           console.log("Navigation executed successfully");
  //         } catch (navError) {
  //           console.error("Navigation error:", navError);
  //         }
  //       }, 2000);
  //     } catch (error) {
  //       status = "Failure";
  //       console.error("Error in handleSubmit:", error);
  //       handleError(error);

  //       // Audit logging for failure
  //       let auditDto = {
  //         UserAccountId: accountId,
  //         CampaignId: 0,
  //         AdvertiserWorkspaceId: workspaceId,
  //         Action: "SignUp platform",
  //         ActionPage: "sign up with workspace creation",
  //         Status: "Failure",
  //         BeforeData: JSON.stringify({}),
  //         AfterData: JSON.stringify({
  //           message: "Signup failed"
  //         }),
  //         IpAddress: userIP,
  //         Comments: "User signup failed",
  //       };

  //       try {
  //         await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
  //       } catch (auditError) {
  //         console.error("Failed to insert audit history:", auditError);
  //       }

  //       setIsButtonDisabled(false);
  //       setLoading(false);
  //     }
  //   };


  const createStarterPlan = async (
    accountId: number,
    normalizedBillingCountry: string
  ) => {
    let status = "Success";
    const payload = {
      BillingCountry: normalizedBillingCountry,
      AccountId: accountId,
      Email: email,
      baseworkspace_id: null,

    };
    // let status = "Success";

    // Initialize auditDto with common fields
    const auditDto = {
      UserAccountId: accountId,
      CampaignId: 0,
      AdvertiserWorkspaceId: createworkspaceId,
      Action: "Create Starter Plan",
      ActionPage: "Workspace Creation",
      Status: "", // Will be set dynamically
      BeforeData: JSON.stringify({}),
      AfterData: "", // Will be set dynamically

      Comments: "", // Will be set dynamically
    };

    try {
      const response = await axios.post(`${apiUrl}/CreateStarterPlan`, payload);

      status = response.data.status;
      const message = response.data.status_Description;
      debugger;
      if (status === "Success") {
        console.log("Starter plan created successfully.");
        debugger;
        auditDto.Status = status;
        console.log("starterplanauditdto;", auditDto.Status);
      } else if (status === "NotAllowed") {
        // toast.toast({
        //   title: "Info",
        //   description: "You’ve already used the free tier. Please choose a paid plan.",
        // });
      }

      // Set dynamic audit fields for success
      auditDto.Status = status;
      auditDto.AfterData = JSON.stringify({ payload, response: response.data });
      auditDto.Comments = status === "Success" ? "Starter plan created successfully." : message || "Starter plan creation failed.";

      return response.data;
    } catch (error) {
      status = "Failure";

      // Set dynamic audit fields for failure
      auditDto.Status = status;
      auditDto.AfterData = JSON.stringify({ payload });
      auditDto.Comments = "Failed to create starter plan.";

      console.error("Error creating starter plan:", error);
      throw error;
    } finally {
      // Single audit API call
      try {
        await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
      } catch (auditError) {
        console.error("Failed to insert audit history for Create Starter Plan:", auditError);
      }
    }
  };


  const registerUser = async () => {
    let status = "Success";
    // Initialize auditDto with common fields
    const auditDto = {
      UserAccountId: accountId, // Use accountId from Redux or null if not available
      CampaignId: 0,
      AdvertiserWorkspaceId: baseworkspace_id,
      Action: "User Registration",
      ActionPage: "Workspace Creation",
      Status: "", // Will be set dynamically
      BeforeData: JSON.stringify({}),
      AfterData: "", // Will be set dynamically
      IpAddress: userIP,
      Comments: "", // Will be set dynamically
    };

    try {
      const response = await axios.post(`${apiUrl}/UserRegister`, signupData);
      if (response.data[0].Status !== "Success") {
        status = "Failure";
        throw new Error("User registration failed");
      }

      // Set dynamic audit fields for success
      auditDto.Status = "Success";
      auditDto.AfterData = JSON.stringify({ signupData, response: response.data });
      auditDto.Comments = "User successfully registered.";

      console.log("User registered successfully");
    } catch (error) {
      // Set dynamic audit fields for failure
      auditDto.Status = "Failure";
      auditDto.AfterData = JSON.stringify({ signupData });
      auditDto.Comments = "Failed to register user.";

      console.error("Error in user registration:", error);
      throw error;
    } finally {
      // Single audit API call
      try {
        await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
      } catch (auditError) {
        console.error("Failed to insert audit history for User Registration:", auditError);
      }
    }
  };

  const getaccountId = async (Email: string) => {
    const Account_response = await axios.post(
      `${apiUrl}/GetUserAccountByEmail`,
      {
        email: emailId,
      }
    );
    if (Account_response.data[0]?.Status === "Success") {
      const userAccountId = Account_response.data[0]?.User_Account_Id;
      dispatch(setAccountId(userAccountId));
      setAccountIdentifier(userAccountId);
      console.log("Account_ID :", userAccountId);
      return userAccountId;
    } else {
      console.log("User account ID not found");
    }
  };


  const insertPersonalInfo = async () => {
    let status = "Success";
    // Initialize auditDto with common fields
    let accountId = await getaccountId(email);
    if (!accountId) throw new Error("AccountId not found");
    const auditDto = {
      UserAccountId: accountId || null, // Use accountId from Redux or null
      CampaignId: 0,
      AdvertiserWorkspaceId: baseworkspace_id || null,
      Action: "Insert Personal Info",
      ActionPage: "Workspace Creation",
      Status: "", // Will be set dynamically
      BeforeData: JSON.stringify({}),
      AfterData: "", // Will be set dynamically
      IpAddress: userIP,
      Comments: "", // Will be set dynamically
    };

    try {
      const response = await axios.post(
        `${apiUrl}/InsertUserPersonalInfo`,
        personalData
      );

      if (response.data.status !== "Success") {
        status = "Failure";
        throw new Error("Failed to insert personal data");
      }

      // Set dynamic audit fields for success
      auditDto.Status = "Success";
      auditDto.AfterData = JSON.stringify({ payload: personalData, response: response.data });
      auditDto.Comments = "Personal info inserted successfully.";
    } catch (error) {
      // Set dynamic audit fields for failure
      auditDto.Status = "Failure";
      auditDto.AfterData = JSON.stringify({ payload: personalData });
      auditDto.Comments = "Failed to insert personal info.";

      console.error("Error inserting personal info:", error);
      throw error;
    } finally {
      // Single audit API call
      try {
        await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
      } catch (auditError) {
        console.error("Failed to insert audit history for Insert Personal Info:", auditError);
      }
    }
  };


  const createWorkspace = async (payload: any) => {
    let status = "Success";
    // Initialize auditDto with common fields
    let accountId = await getaccountId(email);
    if (!accountId) throw new Error("AccountId not found");
    const auditDto = {
      UserAccountId: accountId || null, // Use accountId from Redux or null
      CampaignId: 0,
      AdvertiserWorkspaceId: baseworkspace_id || null, // May be null if not yet set
      Action: "Create Workspace",
      ActionPage: "Workspace Creation",
      Status: "", // Will be set dynamically
      BeforeData: JSON.stringify({}),
      AfterData: "", // Will be set dynamically
      IpAddress: userIP,
      Comments: "", // Will be set dynamically
    };

    try {
      const response = await axios.post(`${apiUrl}/InsertWorkspaceInfo`, payload);

      if (response.data.status !== "Success") {
        status = "Failure";
        throw new Error("Failed to create workspace");
      }

      // Set dynamic audit fields for success
      auditDto.Status = "Success";
      auditDto.AfterData = JSON.stringify({ payload, response: response.data });
      auditDto.Comments = `Workspace ${payload.workspaceName} created successfully with ID ${response.data.workspaceId}.`;

      return response.data.workspaceId;
    } catch (error) {
      // Set dynamic audit fields for failure
      auditDto.Status = "Failure";
      auditDto.AfterData = JSON.stringify({ payload });
      auditDto.Comments = "Failed to create workspace.";

      console.error("Error creating workspace:", error);
      throw error;
    } finally {
      // Single audit API call
      try {
        await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
      } catch (auditError) {
        console.error("Failed to insert audit history for Create Workspace:", auditError);
      }
    }
  };

  const insertOperatorSummary = async (payload: any) => {
    let status = "Success";
    // Initialize auditDto with common fields
    let accountId = await getaccountId(email);
    if (!accountId) throw new Error("AccountId not found");
    const auditDto = {
      UserAccountId: accountId || null, // Use accountId from Redux or null
      CampaignId: 0,
      AdvertiserWorkspaceId: baseworkspace_id || null, // May be null if not yet set
      Action: "Insert Operator Summary",
      ActionPage: "Workspace Creation",
      Status: "", // Will be set dynamically
      BeforeData: JSON.stringify({}),
      AfterData: "", // Will be set dynamically
      IpAddress: userIP,
      Comments: "", // Will be set dynamically
    };

    try {
      const response = await axios.post(
        `${OperatorUrl}/InsertOperatorSummary`,
        payload
      );

      if (response.data.status !== "Success") {
        status = "Failure";
        throw new Error("Failed to insert operator summary");
      }

      // Set dynamic audit fields for success
      auditDto.Status = "Success";
      auditDto.AfterData = JSON.stringify({ payload, response: response.data });
      auditDto.Comments = `Operator summary for partner ${payload.partnerName} inserted successfully.`;

      return true;
    } catch (error) {
      // Set dynamic audit fields for failure
      auditDto.Status = "Failure";
      auditDto.AfterData = JSON.stringify({ payload });
      auditDto.Comments = "Failed to insert operator summary.";

      console.error("Error inserting operator summary:", error);
      throw error;
    } finally {
      // Single audit API call
      try {
        await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
      } catch (auditError) {
        console.error("Failed to insert audit history for Insert Operator Summary:", auditError);
      }
    }
  };

  const assignUserRole = async (email: string, selectedMode: string, workspaceId: number) => {
    let status = "Success";
    let accountId = await getaccountId(email);
    if (!accountId) throw new Error("AccountId not found");
    const payload = {
      Mode: selectedMode,
      EmailId: email,
    };

    // Initialize auditDto with common fields
    const auditDto = {
      UserAccountId: accountId || null, // Use accountId from Redux or null
      CampaignId: 0,
      AdvertiserWorkspaceId: workspaceId || null, // May be null if not yet set
      Action: "Assign User Role",
      ActionPage: "Workspace Creation",
      Status: "", // Will be set dynamically
      BeforeData: JSON.stringify({}),
      AfterData: "", // Will be set dynamically
      IpAddress: userIP,
      Comments: "", // Will be set dynamically
    };

    try {
      const response = await axios.post(`${apiUrl}/InsertUserWorkspaceRole`, payload);

      if (response.status !== 200 || response.data.status !== "Success") {
        status = "Failure";
        throw new Error("Failed to assign user role");
      }

      // Set dynamic audit fields for success
      auditDto.Status = "Success";
      auditDto.AfterData = JSON.stringify({ payload, response: response.data });
      auditDto.Comments = `User role ${selectedMode} assigned successfully to ${email}.`;
    } catch (error) {
      // Set dynamic audit fields for failure
      auditDto.Status = "Failure";
      auditDto.AfterData = JSON.stringify({ payload });
      auditDto.Comments = `Failed to assign user role ${selectedMode} to ${email}.`;

      console.error("Error assigning user role:", error);
      throw error;
    } finally {
      // Single audit API call
      try {
        await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
      } catch (auditError) {
        console.error("Failed to insert audit history for Assign User Role:", auditError);
      }
    }
  };

  const assignUserRoleDropdown = async (email: string, workspace_id: any) => {
    let status = "Success";
    let accountId = await getaccountId(email);
    if (!accountId) throw new Error("AccountId not found");
    const payload = {
      Mode: "InsertFromDialogDropdown",
      EmailId: email,
      WorkspaceId: workspace_id,
    };

    // Initialize auditDto with common fields
    const auditDto = {
      UserAccountId: accountId || null, // Use accountId from Redux or null
      CampaignId: 0,
      AdvertiserWorkspaceId: workspace_id || null, // Use provided workspace_id
      Action: "Assign User Role (Dropdown)",
      ActionPage: "Workspace Creation",
      Status: "", // Will be set dynamically
      BeforeData: JSON.stringify({}),
      AfterData: "", // Will be set dynamically
      IpAddress: userIP,
      Comments: "", // Will be set dynamically
    };

    try {
      const response = await axios.post(`${apiUrl}/InsertUserWorkspaceRole`, payload);

      if (response.status !== 200 || response.data.status !== "Success") {
        status = "Failure";
        throw new Error("Failed to assign user role");
      }

      // Set dynamic audit fields for success
      auditDto.Status = "Success";
      auditDto.AfterData = JSON.stringify({ payload, response: response.data });
      auditDto.Comments = `User role assigned successfully to ${email} for workspace ${workspace_id} from dropdown.`;
    } catch (error) {
      // Set dynamic audit fields for failure
      auditDto.Status = "Failure";
      auditDto.AfterData = JSON.stringify({ payload });
      auditDto.Comments = `Failed to assign user role to ${email} for workspace ${workspace_id} from dropdown.`;

      console.error("Error assigning user role from dropdown:", error);
      throw error;
    } finally {
      // Single audit API call
      try {
        await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
      } catch (auditError) {
        console.error("Failed to insert audit history for Assign User Role (Dropdown):", auditError);
      }
    }
  };

  const fetchWorkspaceDetails = async (email: string) => {
    const response = await axios.get(
      `${apiUrl}/GetWorkspaceNameByEmail?EmailId=${email}`
    );
    if (response.status !== 200 || response.data.status !== "Success")
      throw new Error("Failed to fetch workspace details");

    return {
      path: response.data.workspaceName.workspace_name || "Admin",
      workspaceId: response.data.workspaceName.workspace_id,
      workspaceType: response.data.workspaceName.workspace_type,
    };
  };

  //  const insertbillingstatus = async (workspaceid: number) => 
  //   {
  //     let status = "Success";
  //               let accountId = await getaccountId(email);
  //       if (!accountId) throw new Error("AccountId not found");
  //     const requestParams = { workspaceid }; // Capture query parameter

  //     // Initialize auditDto with common fields
  //     const auditDto = {
  //       UserAccountId: accountId , // Use accountId from Redux or null
  //       CampaignId: 0,
  //       AdvertiserWorkspaceId: workspaceid || null, // Use provided workspaceid
  //       Action: "Insert Billing Status",
  //       ActionPage: "Workspace Creation",
  //       Status: "", // Will be set dynamically
  //       BeforeData: JSON.stringify({}),
  //       AfterData: "", // Will be set dynamically
  //       IpAddress: userIP,
  //       Comments: "", // Will be set dynamically
  //     };

  //     try {
  //       const response = await axios.post(
  //         `${apiUrl}/InsertWorkspaceBillingStatus?workspaceid=${workspaceid}`
  //       );

  //       if (response.data.status !== "Success") {
  //         status = "Failure";
  //         throw new Error(
  //           response.data.status_description || "Failed to insert billing details"
  //         );
  //       }

  //       // Set dynamic audit fields for success
  //       auditDto.Status = "Success";
  //       auditDto.AfterData = JSON.stringify({ requestParams, response: response.data });
  //       auditDto.Comments = `Billing status inserted successfully for workspace ${workspaceid}.`;

  //       setAuthenticated(true);
  //       dispatch(setisAuthstate(true));
  //     } catch (error) {
  //       // Set dynamic audit fields for failure
  //       auditDto.Status = "Failure";
  //       auditDto.AfterData = JSON.stringify({ requestParams});
  //       auditDto.Comments = `Failed to insert billing status for workspace ${workspaceid}.`;

  //       console.error("Error inserting billing status:", error);
  //       throw error;
  //     } finally {
  //       // Single audit API call
  //       // try {
  //       //   await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, auditDto);
  //       // } catch (auditError) {
  //       //   console.error("Failed to insert audit history for Insert Billing Status:", auditError);
  //       // }
  //     }
  //   };


  // const insertbillingstatus = async (workpaceid: number) => {
  //   const response = await axios.post(
  //     `${apiUrl}/InsertWorkspaceBillingStatus?workspaceid=${workpaceid}`
  //   );
  //   if (response.data.status !== "Success")
  //     throw new Error(
  //       response.data.status_description || "Failed to insert billing details"
  //     );
  //   setAuthenticated(true);
  // };

  const fetchAndStorePermissions = async (roleId: number) => {
    const response = await axios.get(
      `${apiUrl}/GetPermissionsByRoleId?RoleID=${roleId}`
    );
    if (response.data.status !== "Success")
      throw new Error(
        response.data.status_description || "Failed to fetch permissions"
      );

    const permissions = JSON.parse(response.data.roleDetails.permissions);
    const role_name = response.data.roleDetails.roleName;
    dispatch(setPermissions(permissions));
    dispatch(setUser_Role_Name(role_name));
  };

  const handleError = (error: any) => {
    console.error("Error:", error);
    toast.toast({
      title: "Error",
      description:
        error.message || "An unexpected error occurred. Please try again.",
    });
  };

  const GetWorkspaceDetailsByID = async () => {
    setLoading(true);
    debugger;
    try {
      const response = await axios.post(
        `${advUrl}/GetWorkspaceDetailsByWorkspaceID`,
        {
          workspaceId: baseworkspace_id,
        }
      );

      if (response.data.length > 0 && response.data[0].Status === "Success") {
        const isoCodeRaw = response.data[0].Billing_Country_ISO;
        const label = response.data[0].Billing_Country_Name;

        console.log("Fetched ISO code:", isoCodeRaw);
        console.log("Fetched Country Name:", label);

        // ✅ Only continue if ISO code is valid
        if (typeof isoCodeRaw === "string") {
          const isoCode = isoCodeRaw.toUpperCase(); // ✅ Safe toUpperCase
          dispatch(setBaseBillingCountryAuth(isoCode));
          dispatch(setBaseBillingCountryLabel(label));

          const timezones = getTimezonesByCountryISO(isoCode); // ✅ No TS error now
          setCountryTimezones(timezones);

          if (timezones.length > 0) {
            const firstTz = timezones[0];
            setSelectedTimezone(`${firstTz.name} (UTC${firstTz.utcOffsetStr})`);
          }
        } else {
          console.warn("Billing_Country_ISO is not a valid string.");
        }
      } else {
        console.warn("No billing country details found in response.");
      }
    } catch (error) {
      console.error("Error fetching billing country", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleBackButton = () => {
    dispatch(setAuthProfileBack(true));
    setNext(false);
  };

  return (
    <>
      {!addWorkspaceFromDropdown ? (
        <>
          {loading && (
            <div className="loading-overlay flex items-center justify-center h-screen">
              <CircularProgress color="primary" />
            </div>
          )}

          <Container maxWidth="xs" sx={{ padding: 2 }}>
            <Toaster />
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ display: "flex", flexDirection: "column", gap: 1 }}
            >
              <div className="mt-2 mb-6">
                <div style={{ marginTop: "0rem", marginBottom: "0px" }}>
                  <ProgressBar currentStep={2} />
                  {/* {/* </div> */}
                  <div className="flex justify-between items-center mt-6 ">
                    {" "}
                    {/* Arrow at 60px from top */}
                    {/* Removed 2/2 label */}
                    <span
                      style={{
                        textAlign: "left",
                      }} /* Text at 70px from top */
                      className="text-[24px] text-[#09090B] font-semibold"
                    >
                      Create your workspace
                    </span>
                    <ArrowLeftIcon
                      onClick={handleBackButton}
                      className="cursor-pointer"
                    />
                  </div>

                  <div className="grid w-full max-w-md items-start gap-1.5 mt-1">
                    <Label
                      htmlFor="companyLogo"
                      className="whitespace-nowrap text-left font-medium text-[14px] text-[#020617]"
                      style={{ marginTop: "1rem" }}
                    >
                      Company logo
                    </Label>
                    <div className="flex w-full items-center gap-2">
                      <Input
                        type="text"
                        value={fileName}
                        readOnly
                        className="flex-grow w-[80%] border-[#E2E8F0] placeholder-[#64748B]"
                        placeholder="Choose File   No file chosen"
                        style={{ fontWeight: 500 }}
                      />
                      <Button
                        type="button"
                        onClick={handleUploadClick}
                        className="font-medium text-[14px] bg-[#F1F5F9] w-[30%] text-[#0F172A] hover:bg-gray-300 focus:ring-[#F1F5F9]  mt--1"
                        style={{
                          height: "2.2rem",
                          padding: "0 0.5rem",
                          fontSize: "0.8rem",
                        }}
                      >
                        Upload image
                      </Button>
                    </div>
                    <input
                      ref={fileInputRef}
                      id="companyLogo"
                      type="file"
                      accept="image/*"
                      className="sr-only"
                      onChange={handleFileChange}
                    />
                    <p
                      className="text-sm text-gray-500 mt-0"
                      style={{
                        textAlign: "left",
                        fontSize: "13px",
                        color: "#64748B",
                      }}
                    >
                      * .png, * .jpeg files up to 5MB at least 400px by 400px
                    </p>
                  </div>

                  <div className="grid w-full max-w-md items-start gap-1.5">
                    <Label
                      htmlFor="companyname"
                      className="whitespace-nowrap text-left font-medium text-[14px] text-[#020617]"
                      style={{ marginTop: "0.6rem" }}
                    >
                      Company name
                    </Label>
                    <Input
                      required
                      id="companyname"
                      placeholder="Enter your company name.."
                      className="w-full border-gray-200 placeholder:font-normal placeholder:text-[#64748B] rounded-[7px] custom-placeholder"
                      onChange={handleFirstNameChange}
                    />
                    {CompanyNameError && (
                      <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                        {CompanyNameError}
                      </p>
                    )}
                  </div>

                  <div className="grid w-full max-w-md items-start gap-1.5">
                    <Label
                      htmlFor="workspacetype"
                      className="whitespace-nowrap text-left font-medium text-[14px] text-[#020617]"
                      style={{ marginTop: "0.6rem" }}
                    >
                      Workspace type
                    </Label>
                    <Select
                      value={selectedWorkspaceType} // ✅ ensures "Advertiser" shows in dropdown top
                      onValueChange={(value) => {
                        console.log("Raw Value from Dropdown:", value); // Log the raw value
                        setSelectedWorkspaceType(value); // Update state
                        checkOperatorType(value);
                      }}
                    >
                      <SelectTrigger className="w-full border-gray-200 relative">
                        <SelectValue>
                          {workspace_types.find(
                            (w) => w.id.toString() === selectedWorkspaceType
                          )?.label || "Advertiser"}
                        </SelectValue>
                      </SelectTrigger>
                      <SelectContent className="fixed z-50 max-h-60 overflow-auto">
                        {workspace_types
                          .filter(
                            (data) =>
                              data.id !== 2 ||
                              (data.id === 2 && isOperatorDomain)
                          )
                          .map((data) => (
                            <SelectItem
                              className="cursor-pointer"
                              key={data.id}
                              value={data.id.toString()}
                            >
                              <div className="flex items-center w-full">
                                <span>{data.label}</span>
                                {selectedWorkspaceType === data.label && (
                                  <CheckIcon className="ml-2" />
                                )}
                              </div>
                            </SelectItem>
                          ))}
                      </SelectContent>
                    </Select>
                  </div>

                  {selectedWorkspaceType === "1" && (
                    <div className="grid w-full max-w-md items-start gap-1.5">
                      <Label
                        htmlFor="companyindustry"
                        className="whitespace-nowrap text-left font-medium text-[14px] text-[#020617]"
                        style={{ marginTop: "0.6rem" }}
                      >
                        Company industry
                      </Label>
                      <Select
                        value={selectedIndustry}
                        onValueChange={(value) => setSelectedIndustry(value)}
                      >
                        <SelectTrigger className="w-full border-gray-200 relative">
                          <SelectValue /> {/* ✅ auto displays selected value */}
                        </SelectTrigger>

                        <SelectContent className="absolute z-50 top-full max-h-40 overflow-auto">
                          {industries.map((data) => (
                            <SelectItem
                              className="cursor-pointer"
                              key={data.id}
                              value={data.id.toString()}
                            >
                              <div className="flex items-center w-full">
                                <span>{data.label}</span>
                                {selectedIndustry === data.label}
                              </div>
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                  )}

                  <div className="grid w-full max-w-md items-start gap-1.5">
                    <Label
                      htmlFor="billingcountry"
                      className="whitespace-nowrap text-left font-medium text-[14px] text-[#020617]"
                      style={{ marginTop: "0.6rem" }}
                    >
                      {OperatorType ? "Country" : "Billing Country"}
                    </Label>
                    <Select
                      value={billingCountry}
                      onValueChange={(value) => {
                        setBillingCountry(value); // value is the label
                        const selected = countries.find(
                          (c) => c.label === value
                        );
                        if (selected) {
                          // pull zones for the newly‑picked country
                          const zones = getTimezonesByCountryISO(selected.iso);
                          setCountryTimezones(zones);
                          if (zones.length > 0) {
                            setSelectedTimezone(
                              `${zones[0].name} (UTC${zones[0].utcOffsetStr})`
                            );
                          }
                        }
                      }}
                    >
                      <SelectTrigger className="w-full border-gray-200 relative">
                        <SelectValue />{" "}
                        {/* shows United Arab Emirates on first render */}
                      </SelectTrigger>

                      <SelectContent className="absolute z-50 top-full max-h-36 overflow-auto">
                        {countries.map((c) => (
                          <SelectItem
                            className="cursor-pointer"
                            key={c.id}
                            value={c.label}
                          >
                            {" "}
                            {/*  👈  label, not id */}
                            {c.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  <div className="grid w-full max-w-md items-start gap-1.5">
                    <Label
                      htmlFor="timezone"
                      className="whitespace-nowrap text-left font-medium text-[14px] text-[#020617]"
                      style={{ marginTop: "0.6rem" }}
                    >
                      Time Zone
                    </Label>
                    <Select
                      value={selectedTimezone}
                      onValueChange={setSelectedTimezone}
                    >
                      <SelectTrigger className="w-full border-gray-200 relative">
                        <SelectValue placeholder="Select TimeZone" />{" "}
                        {/* shows Asia/Dubai (UTC+04:00) immediately */}
                      </SelectTrigger>

                      <SelectContent className="absolute z-50 max-h-24 overflow-auto shadow-md border bg-white rounded">
                        {countryTimezones.map((tz) => {
                          const fmt = `${tz.name} (UTC${tz.utcOffsetStr})`;
                          return (
                            <SelectItem
                              className="cursor-pointer"
                              key={tz.name}
                              value={fmt}
                            >
                              {fmt}
                            </SelectItem>
                          );
                        })}
                      </SelectContent>
                    </Select>
                  </div>

                  <Button
                    type="submit"
                    className="w-full mt-4 bg-[#007AFF] text-[#FAFAFA] font-medium text-[14px]"
                    style={{
                      padding: "0.4rem",
                      height: "2rem",
                    }}
                    disabled={isButtonDisabled} // Disable the button
                  >
                    {isButtonDisabled ? "Processing..." : "Complete"}
                  </Button>
                </div>
              </div>
            </Box>
          </Container>
        </>
      ) : (
        <>
          {loading ? (
            <div className="flex items-center justify-center">
              <CircularProgress color="primary" />
            </div>
          ) : (
            <Box
              component="form"
              onSubmit={handleAddWorkspaceFromDropdown}
              sx={{ display: "flex", flexDirection: "column" }}
              className="space-y-3"
            >
              <div className="grid w-full items-start gap-1.5">
                <Label
                  htmlFor="companyLogo"
                  className="whitespace-nowrap text-left"
                  style={{
                    fontSize: "14px",
                    color: "#020617",
                    fontWeight: 500,
                  }}
                >
                  Company logo
                </Label>
                <div className="flex w-full items-center gap-2">
                  <Input
                    type="text"
                    value={fileName}
                    readOnly
                    className="flex-grow w-[80%] border-gray-400"
                    placeholder="Choose File   No file chosen"
                  />
                  <Button
                    type="button"
                    onClick={handleUploadClick}
                    className="bg-gray-200 w-[30%] text-gray-700 hover:bg-gray-300 focus:ring-gray-400 h-8.1 mt--1"
                  >
                    Upload image
                  </Button>
                </div>
                <input
                  ref={fileInputRef}
                  id="companyLogo"
                  type="file"
                  accept="image/*"
                  className="sr-only"
                  onChange={handleFileChange}
                />
                <p
                  className="text-sm text-gray-500"
                  style={{ fontSize: "0.78rem", marginTop: "0.2rem" }}
                >
                  *.png, *.jpeg files up to 5MB at least 400px by 400px
                </p>
              </div>

              <div className="grid w-full items-start gap-1.5 mt-2">
                <Label
                  htmlFor="companyname"
                  className="whitespace-nowrap text-left"
                  style={{
                    fontSize: "14px",
                    marginTop: "0.9rem",
                    color: "#020617",
                    fontWeight: 500,
                  }}
                >
                  Company name
                </Label>
                <Input
                  required
                  id="companyname"
                  placeholder="Enter your company name.."
                  className="w-full border-gray-400 rounded-[7px] custom-placeholder"
                  onChange={handleFirstNameChange}
                />
                {CompanyNameError && (
                  <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                    {CompanyNameError}
                  </p>
                )}
              </div>

              <div className="grid w-full items-start gap-1.5 mt-2">
                <Label
                  htmlFor="workspacetype"
                  className="whitespace-nowrap text-left"
                  style={{
                    fontSize: "14px",
                    marginTop: "0.9rem",
                    color: "#020617",
                    fontWeight: 500,
                  }}
                >
                  Workspace type
                </Label>
                <Input
                  required
                  id="workspacetype"
                  placeholder={
                    workspace_types.find(
                      (w) => w.id.toString() === selectedWorkspaceType
                    )?.label || ""
                  }
                  className="w-full border-gray-200 rounded-[7px] custom-placeholder"
                  disabled
                />
              </div>

              <div className="grid w-full items-start gap-1.5 mt-2">
                <Label
                  htmlFor="billingcountry"
                  className="whitespace-nowrap text-left"
                  style={{
                    fontSize: "14px",
                    marginTop: "0.9rem",
                    color: "#020617",
                    fontWeight: 500,
                  }}
                >
                  Billing country
                </Label>
                <Input
                  required
                  id="billingcountry"
                  placeholder={billingCountryLabel}
                  className="w-full border-gray-200 rounded-[7px] custom-placeholder"
                  disabled
                />
              </div>

              <div className="grid w-full items-start gap-1.5 mt-2">
                <Label
                  htmlFor="companyindustry"
                  className="whitespace-nowrap text-left"
                  style={{
                    fontSize: "14px",
                    marginTop: "0.9rem",
                    color: "#020617",
                    fontWeight: 500,
                  }}
                >
                  Company industry
                </Label>
                <Select
                  value={selectedIndustry}
                  onValueChange={(value) => setSelectedIndustry(value)}
                >
                  <SelectTrigger className="w-full border-gray-200 relative">
                    <SelectValue>
                      {
                        //  Find label for selected ID
                        industries.find(
                          (item) =>
                            item.id.toString() === selectedIndustry?.toString()
                        )?.label || "Select Industry"
                      }
                    </SelectValue>
                  </SelectTrigger>

                  <SelectContent className="absolute z-50 top-full max-h-40 overflow-auto">
                    {industries.map((data) => (
                      <SelectItem
                        key={data.id}
                        value={data.id.toString()}
                        className="cursor-pointer"
                      >
                        <div className="flex items-center w-full">
                          <span>{data.label}</span>
                          {selectedIndustry === data.id.toString()}
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {selectedWorkspaceType === "1" && ( // Show Time Zone only if workspace type is "Advertiser" (id: 1)
                <div className="grid w-full items-start gap-1.5 mt-2">
                  <Label
                    htmlFor="timezone"
                    className="whitespace-nowrap text-left font-medium text-[14px] text-[#020617] mb-1"
                    style={{ marginTop: "0.6rem" }}
                  >
                    Time Zone
                  </Label>
                  <Select
                    onValueChange={(value) => {
                      const selectedTz = countryTimezones.find(
                        (tz) => tz.name === value
                      );
                      if (selectedTz) {
                        setSelectedTimezone(
                          `${selectedTz.name} (UTC${selectedTz.utcOffsetStr})`
                        );
                      } else {
                        setSelectedTimezone("");
                      }
                    }}
                  >
                    <SelectTrigger className="w-full border-gray-200 relative">
                      <SelectValue
                        placeholder={selectedTimezone || "Select Timezone"}
                      />
                    </SelectTrigger>
                    <SelectContent className="absolute z-50 top-full max-h-20 overflow-auto">
                      {countryTimezones.length > 0 ? (
                        countryTimezones.map((tz) => (
                          <SelectItem
                            className="cursor-pointer"
                            key={tz.name}
                            value={tz.name}
                          >
                            <div className="flex items-center w-full">
                              <span className="cursor-pointer">{`${tz.name} (UTC${tz.utcOffsetStr})`}</span>
                            </div>
                          </SelectItem>
                        ))
                      ) : (
                        <div className="px-2 text-gray-500">
                          No timezones available
                        </div>
                      )}
                    </SelectContent>
                  </Select>
                </div>
              )}


              {/* <div className="grid w-full items-start gap-1.5 mt-2">
                  <Label
                    htmlFor="timezone"
                    className="whitespace-nowrap text-left font-medium text-[14px] text-[#020617] mb-1"
                    style={{ marginTop: "0.6rem" }}
                  >
                    Time Zone
                  </Label>
                  <Select
                    onValueChange={(value) => {
                      const selectedTz = countryTimezones.find(
                        (tz) => tz.name === value
                      );
                      if (selectedTz) {
                        setSelectedTimezone(
                          `${selectedTz.name} (UTC${selectedTz.utcOffsetStr})`
                        );
                      } else {
                        setSelectedTimezone("");
                      }
                    }}
                  >
                    <SelectTrigger className="w-full border-gray-200 relative">
                      <SelectValue
                        placeholder={selectedTimezone || "Select Timezone"}
                      />
                    </SelectTrigger>
                    <SelectContent className="absolute z-50 top-full max-h-20 overflow-auto">
                      {countryTimezones.length > 0 ? (
                        countryTimezones.map((tz) => (
                          <SelectItem
                            className="cursor-pointer"
                            key={tz.name}
                            value={tz.name}
                          >
                            <div className="flex items-center w-full">
                              <span className="cursor-pointer">{`${tz.name} (UTC${tz.utcOffsetStr})`}</span>
                            </div>
                          </SelectItem>
                        ))
                      ) : (
                        <div className="px-2 text-gray-500">
                          No timezones available
                        </div>
                      )}
                    </SelectContent>
                  </Select>
                </div> */}


              <Button
                type="submit"
                className="w-full mt-2 bg-[#007AFF] text-[14px] font-medium"
                disabled={isButtonDisabled} // Disable the button
              >
                {isButtonDisabled ? "Processing..." : "Complete"}
              </Button>
            </Box>
          )}
        </>
      )}
    </>
  );
};

const Workspace: FC = () => {
  const loginVideoMP4 = loginVideoUrls.LoginVideoUrl;
  const loginVideoWebM = loginVideoUrls.LoginVideoUrlWebM;
  return (
    <div className="login-page" style={{ display: "flex", height: "100vh" }}>
      <div
        style={{
          position: "fixed",
          top: "30px",
          left: "30px",
          zIndex: 20,
        }}
      >
        <img src={Logo} alt="Logo" style={{ width: "170px", height: "auto" }} />
      </div>
      <div
        className="left-pane"
        style={{
          flex: "1",
          // backgroundImage: url(${figmaPageImage}),
          // backgroundSize: 'cover',
          backgroundPosition: "center",
          height: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          className="background-video"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            objectFit: "fill",
          }}
        >
          <source src={loginVideoWebM} type="video/webm" />
          <source src={loginVideoMP4} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div
        className="right-pane"
        style={{
          flex: "1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="LoginMatCard"
          style={{ width: "90%", maxWidth: "400px" }}
        >
          {/* <CustomWorkspaceControl /> */}
        </div>
      </div>
    </div>
  );
};

export default Workspace;
